import React, { memo } from 'react';
import { ReactComponent as CommentSvg } from '@assets/icons/comment-secondary.svg';
import { Tooltip } from 'antd';

type CommentsCellProps = {
  commentsCount: number;
  onClick: () => void;
};

export default memo(function CommentsCell({
  commentsCount,
  onClick
}: CommentsCellProps) {
  return (
    <Tooltip
      title="Open in media viewer"
      overlayClassName="toggle_favorite_overlay"
      placement="topLeft"
    >
      <div
        className="campaign-approval-table_comments-cell"
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
      >
        <CommentSvg />
        {commentsCount}
      </div>
    </Tooltip>
  );
});
